'use client';

import React from 'react';

export default function TermsPage() {
  return (
    <div className="flex size-full items-start justify-center overflow-y-auto px-4 py-20 sm:px-0">
      <div className="max-w-4xl p-6 leading-7">
        <h1 className="mb-4 text-2xl font-bold">利用規約</h1>

        <p className="mb-4">
          本利用規約（以下「本規約」といいます。）は、株式会社KUDEN
          WORLD（以下「当社」といいます。）が提供するサービスである「KUDEN
          Biz」及びこれに関連するサービスの利用条件及び利用者と当社との間の権利義務関係を定めています。本規約に基づくサービスの利用に際しては、本サービスの利用を開始した時点から、本規約の全文をお読みいただいたうえで、本規約に同意したものとみなします。
        </p>
        <p className="mb-6">
          なお、本利用規約とは別に、当社と利用者との間で個別契約または基本契約を締結している場合には、当該契約の定めが本規約に優先して適用されるものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">1.（定義）</h2>
        <div className="space-y-2">
          <p>
            （1）「本サービス」とは、当社が提供する「KUDEN
            Biz」という名称のサービス（理由の如何を問わず、サービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）及びこれに関連するサービスをいいます。
          </p>
          <p>（2）「契約者」とは、本サービスの利用契約を当社と締結する者をいい、法人または個人を含みます。</p>
          <p>
            （3）「登録ユーザー」とは、契約者本人（契約者が個人である場合を含みます。）または契約者の管理のもとで本サービスを利用する利用者をいいます。
          </p>
          <p>
            （4）「サービス利用契約」とは、本規約を契約条件として当社と契約者との間で締結される、本サービスの利用契約をいいます。
          </p>
          <p>
            （5）「当社ウェブサイト」とは、URL が{' '}
            <a
              href="https://www.business.kuden.world"
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 underline"
            >
              https://www.business.kuden.world
            </a>{' '}
            である、当社が運営するウェブサイト（理由の如何を問わず、当社のウェブサイトのドメインまたは内容が変更された場合は、当該変更後のウェブサイトを含みます。）をいいます。
          </p>
          <p>
            （6）「コンテンツ」とは、本サービスを通じて当社が提供する動画コンテンツ（映像、音声、字幕、その他付随情報を含む）を意味します。登録ユーザーが本サービス上にアップロードする動画コンテンツも含みます。
          </p>
          <p>
            （7）「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（これらの権利を取得し、または登録等を出願する権利を含みます。）をいいます。
          </p>
        </div>

        <h2 className="mb-2 mt-6 text-xl font-bold">2.（適用）</h2>
        <p className="mb-6">
          本規約は、本サービスの提供条件及び本サービスの利用に関する当社と登録ユーザーとの間の権利義務関係を定めることを目的とし、登録ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。特定の会員に対してのみ適用されるサービス等については、当社が本サイトまたは関連するアプリ上で表示する各条件が適用されるものとし、これらの条件を本規約の一部とみなして適用するものとします。本規約の内容と本規約外における本サービスの説明等が相互に矛盾する場合は、本規約に優先する旨の特段の定めがない限り本規約の規定が優先して適用されるものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">3.（必要環境）</h2>
        <p className="mb-6">
          本サービスの利用又は本サービスを通じた第三者のコンテンツ・リソースの利用にはインターネットへの接続が必要となり、その通信料金は登録ユーザーの負担となります。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">4.（登録）</h2>
        <div className="space-y-2">
          <p>
            （1）本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約及び適用される法令等を遵守することに同意し、かつ当社の定める一定の情報（以下「登録事項」といいます。）を当社が定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。
          </p>
          <p>
            （2）契約者は、法人、個人事業主または個人のいずれかとします。契約者が法人である場合、当該契約者は自らの管理のもとで本サービスを利用する社員、役員、契約社員、委託先担当者その他契約者に所属または関係する利用者を登録ユーザーとして登録することができます。契約者が個人である場合は、契約者本人が登録ユーザーとして本サービスを利用するものとします。
          </p>
          <p>
            （3）当社は、登録希望者から提供された登録事項を審査し、当社の基準に従って登録の可否を判断します。当社が登録を認めた場合、その旨を登録希望者に通知し、当該通知をもって契約者の登録が完了するものとします。
          </p>
          <p>
            （4）契約者の登録が完了した時点で、当社と契約者との間にサービス利用契約が成立し、契約者及び登録ユーザーは本規約に従い本サービスを利用することができます。
          </p>
          <p>
            （5）当社は、登録希望者が第12条第2項各号のいずれかに該当すると判断した場合、登録または再登録を拒否することができ、その理由を開示する義務を負いません。
          </p>
          <p>
            （6）登録ユーザーは、以下の事項を遵守するものとします。①虚偽の個人情報を提供しないこと／②アカウントが当社によって停止された場合、当社の許可なく新たなアカウントを作成しないこと。／③登録事項のうち、メールアドレスについて、メールを必ず受け取ることができる状態に保つこと。／④当社は、登録ユーザーのアカウントが当該登録ユーザー以外の第三者によって利用された場合であっても、当該会員による利用とみなすことができるものとします。／⑤登録ユーザーは、本サービス利用にあたり、ソフトウェアの改善・向上のためにアップグレードやアップデート、追加機能のダウンロードが実行されることに同意します。／⑥登録ユーザーは、本サービスより受け取る情報に広告が掲載される可能性や登録した電子メールアドレスに当社からのお知らせや広告等が送信される可能性があることに同意したうえで、本サービスに登録します。
          </p>
        </div>

        <h2 className="mb-2 mt-6 text-xl font-bold">5.（登録事項の変更）</h2>
        <p className="mb-6">
          契約者は、登録事項に変更があった場合、当社の定める方法により当該変更事項を遅滞なく当社に通知するものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">6.（パスワード及びユーザーIDの管理）</h2>
        <p className="mb-6">
          登録ユーザーは、自己の責任において、本サービスに関するパスワード及びユーザーIDを適切に管理及び保管するものとし、これを第三者に利用させ、または貸与、譲渡、名義変更、売買等をしてはならないものとします。パスワードまたはユーザーIDの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任は登録ユーザーが負うものとし、当社は一切の責任を負わないものとします。登録ユーザーは、アカウントが権限のない者によって利用された形跡に気付いた場合、直ちに当社に通知する義務を負うものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">7.（追加有料コンテンツに関する料金及び支払方法）</h2>
        <p className="mb-2">
          登録ユーザーは、本サービスに基づき追加有料コンテンツの提供を受ける場合には、その利用の対価として、別途当社が定め、当社ウェブサイトに表示する利用料金を、当社が指定する支払方法により当社に支払うものとします。
        </p>
        <p className="mb-6">
          追加有料コンテンツの利用の対価は、変更されることがあります。当社が対価の変更をする場合、当社は本サービス上において予め、変更後の利用料金及び利用料金変更の適用開始時期を登録会員が知り得る状態に置くものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">8.（禁止事項）</h2>
        <p className="mb-6">
          登録ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。
        </p>

        <div className="space-y-2">
          <p>（1）法令に違反する行為または犯罪行為に関連する行為</p>
          <p>（2）当社、本サービスの他の利用者またはその他の第三者に対する詐欺または脅迫行為</p>
          <p>（3）公序良俗に反する行為</p>
          <p>
            （4）当社、本サービスの他の利用者またはその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利または利益を侵害する行為
          </p>
          <p>
            （5）本サービスによって提供される音声、肖像等を、録音、録画その他の記録媒体に記録し、または本サービス以外の用途に使用すること
          </p>
          <p>
            （6）本サービスを通じ、以下に該当し、または該当すると当社が判断する情報を当社または本サービスの他の利用者に送信すること
          </p>
          <div className="pl-4">
            <p>⚪︎ 暴力的または残虐な表現を含む情報</p>
            <p>⚪︎ コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報</p>
            <p>⚪︎ 当社、本サービスの他の利用者またはその他の第三者の名誉または信用を毀損する表現を含む情報</p>
            <p>⚪︎ わいせつな表現を含む情報</p>
            <p>⚪︎ 差別を助長する表現を含む情報</p>
            <p>⚪︎ 自殺、自傷行為を助長する表現を含む情報</p>
            <p>⚪︎ 薬物の不適切な利用を助長する表現を含む情報</p>
            <p>⚪︎ 反社会的な表現を含む情報</p>
            <p>⚪︎ チェーンメール等の第三者への情報の拡散を求める情報</p>
            <p>⚪︎ 他人に不快感を与える表現を含む情報</p>
          </div>
          <p>（7）本サービスのネットワークまたはシステム等に過度な負荷をかける行為</p>
          <p>（8）当社が提供するソフトウェアその他のシステムに対するリバースエンジニアリングその他の解析行為</p>
          <p>（9）本サービスの運営を妨害するおそれのある行為</p>
          <p>（10）当社のネットワークまたはシステム等への不正アクセス行為</p>
          <p>（11）第三者に成りすます行為</p>
          <p>（12）本サービスの他の利用者のIDまたはパスワードを利用する行為</p>
          <p>（13）当社が事前に許諾しない本サービス上での宣伝、広告、勧誘、または営業行為</p>
          <p>（14）本サービスの他の利用者の情報の収集行為</p>
          <p>（15）当社、本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為</p>
          <p>（16）反社会的勢力等への利益供与行為</p>
          <p>（17）前各号の行為を直接または間接に惹起し、または容易にする行為</p>
          <p>（18）前各号の行為を試みる行為</p>
          <p>（19）その他、当社が不適切と判断する行為</p>
        </div>

        <h2 className="mb-2 mt-6 text-xl font-bold">9.（コンテンツの利用）</h2>
        <p className="mb-6">
          登録ユーザーは、本サービスにおいて提供されているコンテンツを本サービスの提供形態に即して利用できるものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">10.（登録ユーザーによるコンテンツアップロード）</h2>
        <div className="space-y-2">
          <p>
            登録ユーザーは契約形態により、本サービス上に自身で作成したコンテンツをアップロードすることができます。その場合のコンテンツの取扱いは以下に倣うものとします。
          </p>
          <p>
            （1）アップロードされたコンテンツが法令その他公序良俗に反するものである場合、第三者の知的財産権を侵害するものである場合、コンテンツは当社の判断で削除されます。
          </p>
          <p>
            （2）アップロードされたコンテンツのデータは登録ユーザにおいて管理することとし、当社はいかなる場合においても、アップロードされたコンテンツデータの保存・データ提供・返還には応じません。
          </p>
          <p>
            （3）当社は、スパム、マルウェアその他の違法行為や侵害行為を検出するため、アップロードされたコンテンツを分析することがあります。
          </p>
          <p>
            （4）コンテンツをアップロードすることにより、登録ユーザーは当社に対し、当該コンテンツを使用（複製、配信、派生的著作物の作成、展示・上映、宣伝のための使用を含みます）するための世界的・非独占的且つサブライセンス可能で譲渡可能な権利を無償で付与するものとします。
          </p>
          <p>
            （5）登録ユーザーは、アップロードしたコンテンツに関し、当社及び当社から権利を承継しまたは許諾された者に対して著作者人格権を行使しないことに同意するものとします。
          </p>
          <p>（6）本規約に定めのないデータの取扱いについては、基本契約または個別契約の規定に従うものとします。</p>
        </div>

        <h2 className="mb-2 mt-6 text-xl font-bold">11.（権利帰属）</h2>
        <p className="mb-6">
          当社ウェブサイト及び本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、当社ウェブサイトまたは本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">12.（退会・登録抹消等）</h2>
        <div className="space-y-2">
          <p>
            本サービスの契約解除には、対応端末を通じて、当社が定める手続を行うことによりユーザー登録の解除（以下「退会」といいます）が必要になります。なお、退会手続は、登録ユーザーご本人が行う必要があります。
          </p>
          <p>
            当社は、登録ユーザーが、以下の各号のいずれかの事由に該当する場合は、事前に通知または催告することなく、当該登録ユーザーについて本サービスの利用を一時的に停止し、または登録ユーザーとしての登録を抹消（以下「登録抹消」といいます。）することができます。
          </p>
          <div className="pl-4">
            <p>（1）本規約のいずれかの条項に違反した場合</p>
            <p>（2）当社に提供した登録情報の全部または一部につき虚偽、誤記または記載漏れがあった場合</p>
            <p>
              （3）未成年者、成年被後見人、被保佐人または被補助人のいずれかであり、その法定代理人、後見人、保佐人または補助人の同意等を得ていなかった場合
            </p>
            <p>
              （4）反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）である、または資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した場合
            </p>
            <p>
              （5）支払停止もしくは支払不能となり、または破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合
            </p>
            <p>（6）過去当社との契約に違反した者またはその関係者であると当社が判断した場合</p>
            <p>（7）その他、当社が本サービスの利用または登録ユーザーとしての登録の継続を適当でないと判断した場合</p>
          </div>
          <p>
            前項各号のいずれかの事由に該当した場合、登録ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。退会又は登録抹消と同時に、一切の登録ユーザー専用サービスを利用できなくなります。登録ユーザーは、本条に基づき退会又は登録抹消が完了した時点までの月額料金を支払うものとします。当社は日割り計算に基づく減額は行いません。
          </p>
        </div>

        <h2 className="mb-2 mt-6 text-xl font-bold">13.（本サービスの内容の変更、終了）</h2>
        <p className="mb-6">
          当社は、当社の都合により、本サービスの内容を変更し、または提供を終了することができます。当社が本サービスの提供を終了する場合、当社は登録ユーザーに事前に通知するものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">14.（保証の否認及び免責）</h2>
        <div className="space-y-2">
          <p>
            当社は、本サービスが登録ユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、登録ユーザーによる本サービスの利用が登録ユーザーに適用のある法令または業界団体の内部規則等に適合すること、継続的に利用できること、及び不具合が生じないことについて、明示又は黙示を問わず何ら保証するものではありません。
          </p>
          <p>
            当社は、本サービスの提供する情報の完全性、正確性、合法性等には一切の責任を負いません。当社は、当社の故意または重過失による場合を除き、本サービスに関して登録ユーザーが被った一切の逸失利益その他特別の事情によって生じた損害につき責任を負わないものします。
          </p>
          <p>
            当社の故意または重過失により、本サービスに関して当社が登録ユーザーに対して負う責任は、登録ユーザーに通常生ずべき損害又は当社が登録ユーザーより過去１２か月間に支払いを受けた金額のいずれか低い金額を限度とします。
          </p>
          <p>
            当社は、以下に該当する事由その他当社の不可抗力により当社が本サービスを提供できなかった場合であっても、登録ユーザーに生じた損害について一切責任を負わず、登録ユーザーからの料金減額請求にも応じないものとします。
          </p>
          <div className="pl-4">
            <p>（1）本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合</p>
            <p>
              （2）コンピューター、通信回線等の障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング等により本サービスの運営ができなくなった場合
            </p>
            <p>（3）地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</p>
            <p>
              （4）弊社サービス内で提供されるコンテンツに関して、知的財産権の帰属その他の理由により利用ができなくなる場合
            </p>
            <p>（5）その他、当社が停止または中断を必要と判断した場合</p>
          </div>
          <p>
            当社は、登録ユーザーが本サービスによって得た知識・知見を用いて行った活動（経済的活動であるか否かに関わりません）によって生じた結果について、一切の責任を負わないものとします。本サービスまたは当社ウェブサイトに関連して登録ユーザーと他の登録ユーザーまたは第三者との間において生じた取引、連絡、紛争等については、登録ユーザーが自己の責任によって解決するものとします。
          </p>
        </div>

        <h2 className="mb-2 mt-6 text-xl font-bold">14-1.（サービスレベル及びサポートポリシー）</h2>
        <p className="mb-6">
          当社は、本サービスの稼働率、応答時間、サポート体制その他のサービスレベル（以下「SLA」といいます。）に関する基準を、当社が別途定め、利用者に掲示します。当社は、合理的な範囲において、これらの基準を改定することができるものとし、改定後の内容は、当社が掲示または通知を行った時点で効力を生じるものとします。なお、これらの基準に定めのない事項については、本規約または当社と利用者との間で締結する基本契約または個別契約の定めに従うものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">14-2.（AI・LLMの利用について）</h2>
        <div className="space-y-2">
          <p>
            本サービスには、生成AI（大規模言語モデル（LLM）等を含む。以下「AI」といいます。）を利用する機能が含まれる場合があります。
          </p>
          <p>
            登録ユーザーは、AIによって生成された回答、出力、提案等の内容（以下「AI生成物」といいます。）が常に正確性、完全性、有用性、適法性を保証するものではないことを理解し、自己の判断と責任において利用するものとします。
          </p>
          <p>
            当社は、AI生成物に起因して登録ユーザーまたは第三者に損害が生じた場合であっても、一切の責任を負わないものとします。
          </p>
          <p>
            登録ユーザーは、AI生成物を法令、公序良俗、第三者の権利を侵害しない範囲で利用するものとし、これに違反して生じた責任は登録ユーザー自身が負うものとします。
          </p>
          <p>
            当社は、本サービスにおいて外部事業者が提供する大規模言語モデル（LLM）のAPIを利用する場合があります。当該APIを通じて入力された情報については、当該外部事業者において学習データとして利用されない設定を採用しています。
          </p>
        </div>

        <h2 className="mb-2 mt-6 text-xl font-bold">15.（外部サービスとの連携）</h2>
        <div className="space-y-2">
          <p>
            登録ユーザーは、外部サービスとの連携機能を利用してログインする場合、登録ユーザーが当社に対し、当該外部サービスにおけるデータへのアクセスを許可することを条件として、当該連携機能を利用できるものとします。
          </p>
          <p>
            外部サービスのユーザーIDの登録・利用を含むすべての外部サービスの利用については、登録ユーザーは当該外部サービスの運営者が定める各規約の定めに従うものとします。登録ユーザーは自己の責任において当該外部サービスを利用するものとし、当社は、当該外部サービスの利用により生じた損害、または当該外部サービスの運営者・利用者等の間に生じたトラブルその他一切の事項について、何らの責任も負わないものとします。
          </p>
          <p>
            当社は、本サービスの提供にあたり、生成AI・LLM等の外部システム（例：OpenAI、Google Gemini
            等）を利用します。登録ユーザーは、当社がこれら外部システムに対し、登録ユーザーが入力した情報およびユーザー識別情報（ユーザーネーム等）を送信して処理を委託することについて、あらかじめ同意するものとします。
          </p>
          <p>
            当社は、これら外部システムにおいて、入力情報が学習利用されない設定を採用し、また、個人情報保護法その他関係法令に基づき、適切な安全管理措置を講じるものとします。
          </p>
        </div>

        <h2 className="mb-2 mt-6 text-xl font-bold">16.（秘密保持）</h2>
        <p className="mb-6">
          登録ユーザーは、本サービスに関連して当社が登録ユーザーに対して秘密に取扱うことを求めて開示した非公知の情報について、当社の事前の書面による承諾がある場合を除き、秘密に取扱うものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">17.（利用者情報の取扱い）</h2>
        <p className="mb-6">
          当社による登録ユーザーの利用者情報の取扱いについては、別途当社プライバシーポリシー（
          <a
            href="https://www.business.kuden.world/privacypolicy"
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 underline"
          >
            https://www.business.kuden.world/privacypolicy
          </a>
          ）の定めによるものとし、登録ユーザーはこのプライバシーポリシーに従って当社が登録ユーザーの利用者情報を取扱うことについて同意するものとします。当社は、登録ユーザーが当社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、当社の裁量で、利用及び公開することができるものとし、登録ユーザーはこれに同意するものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">18.（本規約等の変更）</h2>
        <p className="mb-6">
          当社は、当社が必要と認めた場合は、本規約を変更できるものとします。本規約を変更する場合、変更後の本規約の施行時期及び内容を当社ウェブサイト上での掲示その他の適切な方法により周知し、または登録ユーザーに通知します。但し、法令上登録ユーザーの同意が必要となるような内容の変更の場合は、当社所定の方法で登録ユーザーの同意を得るものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">19.（連絡／通知）</h2>
        <p className="mb-6">
          本サービスに関する問い合わせその他登録ユーザーから当社に対する連絡または通知、及び本規約の変更に関する通知その他当社から登録ユーザーに対する連絡または通知は、当社の定める方法で行うものとします。当社が登録事項に含まれるメールアドレスその他の連絡先に連絡または通知を行った場合、登録ユーザーは当該連絡または通知を受領したものとみなします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">20.（サービス利用契約上の地位の譲渡等）</h2>
        <p className="mb-6">
          登録ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。当社は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びに登録ユーザーの登録事項その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、登録ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">21.（分離可能性）</h2>
        <p className="mb-6">
          本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
        </p>

        <h2 className="mb-2 mt-6 text-xl font-bold">22.（準拠法及び管轄裁判所）</h2>
        <p className="mb-6">
          本規約及びサービス利用契約の準拠法は日本法とします。本規約またはサービス利用契約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </p>
      </div>
    </div>
  );
}
